<template>
  <v-container class="switcher-container" :class="color">
    <v-switch
      :value="value"
      hide-details
      :input-value="value"
      inset
      :label="label"
      :class="`switcher_${size}`"
      @change="$emit('change')"
    />
  </v-container>
</template>

<script>
  import { VSwitch, VContainer } from 'vuetify/lib';

  export default {
    name: 'Switcher',
    components: {
      VSwitch,
      VContainer,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
      },
      color: {
        type: String,
        default: 'green',
        validator: (type) => ['green', 'orange', 'blue'].includes(type),
      },
      size: {
        type: String,
        default: 'md',
        validator: (type) => ['sm', 'md'].includes(type),
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .switcher-container {
    padding: 0;
  }

  .green {
    ::v-deep .v-input--is-label-active .v-input--switch__track {
      background-color: $success600;
    }
  }

  .orange {
    ::v-deep .v-input--is-label-active .v-input--switch__track {
      background-color: $warning500;
    }
  }

  .blue {
    ::v-deep .v-input--is-label-active .v-input--switch__track {
      background-color: $text-accent;
    }
  }

  ::v-deep {
    .v-label {
      color: $grey900;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 0;
      margin-left: 8px;
    }
    .v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }
    .v-input--selection-controls__ripple {
      display: none;
    }
    .v-input--is-label-active {
      .v-input--switch__thumb {
        margin-left: 20px;
      }

      .v-input--switch__track {
        opacity: 1;
      }
    }
  }

  .switcher_sm::v-deep {
    &.v-input--is-label-active {
      .v-input--switch__thumb {
        margin-left: 14px;
      }
    }

    .v-input--selection-controls__input {
      width: 38px;
    }

    .v-input--switch__thumb {
      height: 16px;
      width: 16px;
      top: calc(50% - 8px);
      left: 4px;
    }

    .v-input--switch__track {
      left: 0;
      width: 38px;
      height: 24px;
      top: calc(50% - 12px);
    }
  }
</style>
